import React from "react";
/*import SelectionCard from "./selectioncard"
import bhon from "./images/bhon.png";
import chandler from "./images/chandler.png";
import climate_control from "./images/climate-control.png";
import larkin from "./images/larkin.png";
import hermetic from "./images/hermetic.png";
import scroll from "./images/scroll.png";
import scroll from "./images/scroll.png";*/
import { useTranslation } from 'react-i18next';

export default function PdtHeader(props) {
    const { t, i18n } = useTranslation();

    var head = props.unit;
    if(head == "Quickloader") head ="Quick Box Load"
    return (
    <div className="row m-0"> 
    <div className="col-sm-12  bg-head ">
        <div className="custom_container p-0">
            <p className="p_select">{t('choose_pdt.product_selector')}</p>
                <b className="font32"> {(props.tool ==="System")?<>{t('unit_names.system')}</>:<>{head}</>} </b>
            
        </div>
        </div>
    </div>
    )
}